module.exports = __webpack_public_path__ + "static/media/getResearch.68e1bda1.svg";